import React from 'react';

export default function  Cross({ onClick }) {
  return (
    <svg className="g__close"
         width="32"
         height="32"
         viewBox="0 0 32 32"
         fill="none"
         onClick={onClick}
         xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 17.5385L24.4615 26L26 24.4615L17.5385 16L26 7.53846L24.4615 6L16 14.4615L7.53846 6L6 7.53846L14.4615 16L6 24.4615L7.53846 26L16 17.5385Z"></path>
    </svg>
  )
}